module.exports = __webpack_public_path__ + "static/media/money-bill-alt.c95705bc.svg";